<template>
  <div>
    <b-sidebar
      id="sidebar-documents"
      aria-label="Sidebar with custom footer"
      backdrop
      right
      shadow
    >
      <b-card>
        <b-card-header>
          <b-row>
            <b-col cols="12" class="mt-2 mt-sm-0">
              <div class="card-header-actions">
                <div style="display: flex; justify-content: space-between">
                  <b-form-group size="sm" class="mb-0 mr-1">
                    <b-input-group>
                      <b-form-input
                        size="sm"
                        v-model="find"
                        placeholder="Search downloads"
                      ></b-form-input>
                      <b-input-group-append>
                        <b-button
                          size="sm"
                          style="width: auto; padding: 0.25rem 0.6rem"
                          variant="outline-primary"
                          :disabled="!find"
                          @click="find = ''"
                        >
                          <i v-if="find" class="fa fa-remove"></i>
                          <i v-if="!find" class="fa fa-search"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-header>
        <b-card-body class="text-muted">
          <div class="px-3 py-2">
            <!--    {{ files }} -->

            <b-row v-if="filesview == 1">
              <b-col>
                <b-table
                  hover
                  small
                  responsive="sm"
                  caption-bottom
                  stacked="md"
                  show-empty
                  :fields="options.fields"
                  :filter="find"
                  :items="files"
                  class="mb-0"
                >
                  <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                      <b-spinner
                        variant="primary"
                        class="align-middle"
                      ></b-spinner>
                    </div>
                  </template>
                  <template v-slot:empty="scope">
                    <p v-if="scope" class="text-center mt-2 mb-0">
                      {{ messagenofiles }}
                    </p>
                  </template>
                  <template v-slot:cell(name)="row">
                    <a target="_blank" :href="row.item.url">{{
                      row.item.name
                    }}</a>
                  </template>
                  <template v-slot:cell(icon)="row">
                    <i :class="row.item.icon" class="brand-color"></i>
                  </template>
                  <template v-slot:cell()="row">
                    <div
                      v-if="
                        options.badges &&
                        options.badges.find((obj) => obj.key == row.field.key)
                      "
                    >
                      <span
                        v-html="
                          $helpers.badgeField(
                            row.item,
                            options.badges.find(
                              (obj) => obj.key == row.field.key
                            ),
                            options
                          )
                        "
                      ></span>
                    </div>
                    <div v-else>{{ row.value }}</div>
                  </template>
                  <template v-if="options.actions" v-slot:cell(actions)="row">
                    <div
                      id="actions-container"
                      v-if="options.actions_as_elipses"
                    >
                      <b-button
                        variant="link"
                        size="sm"
                        title="Actions"
                        :id="'popover-target-' + row.item.id"
                        @click="$root.$emit('bv::hide::popover')"
                      >
                        <i class="fa fa-ellipsis-h text-primary"></i>
                      </b-button>
                      <b-popover
                        container="actions-container"
                        triggers="click blur"
                        placement="leftbottom"
                        :target="'popover-target-' + row.item.id"
                      >
                        <div>
                          <b-nav vertical>
                            <b-nav-item
                              :title="action.label"
                              v-for="action in $helpers.actionsValid(
                                row.item,
                                options
                              )"
                              :key="action.key"
                              @click.stop="table_action(action.key, row)"
                            >
                              <b-row class="px-2">
                                <b-col class="px-0">
                                  <span class="text-normal">{{
                                    action.label
                                  }}</span>
                                </b-col>
                                <b-col cols="1">
                                  <i
                                    :class="action.icon"
                                    class="text-primary"
                                  ></i>
                                </b-col>
                              </b-row>
                            </b-nav-item>
                          </b-nav>
                        </div>
                      </b-popover>
                    </div>
                    <div v-else>
                      <b-button
                        variant="link"
                        size="sm"
                        v-for="action in $helpers.actionsValid(
                          row.item,
                          options
                        )"
                        :key="action.key"
                        @click.stop="table_action(action.key, row)"
                        :title="action.label"
                      >
                        <i :class="action.icon" class="text-primary"></i>
                      </b-button>
                    </div>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row v-if="filesview == 2">
              <b-col>
                <b-card-group deck class="pl-0 pr-0">
                  <p v-if="files.length === 0" class="text-center mb-0 w-100pc">
                    {{ messagenofiles }}
                  </p>
                  <b-row no-gutters class="w-100pc">
                    <b-col
                      v-for="(file, index) in files"
                      :key="index"
                      cols="12"
                      md="12"
                      class="pl-0"
                    >
                      <b-card no-body class="details mb-2">
                        <a target="_blank" :href="file.url">
                          <div
                            class="text-center fileimage"
                            v-if="setIcon(file.filename) == 'fa-file-image-o'"
                          >
                            <b-card-img
                              top
                              :src="file.url"
                              alt="Image"
                              class
                            ></b-card-img>
                          </div>
                          <div v-else class="text-center fileimage">
                            <div class="d-block">
                              <i
                                :class="
                                  'fa ' +
                                  setIcon(file.filename) +
                                  ' fa-3x primary my-3'
                                "
                              ></i>
                            </div>
                          </div>
                        </a>
                        <b-card-body class="pl-1 pb-0">
                          <b-card-title
                            v-if="file.filename"
                            class="filetitle"
                            >{{ file.filename }}</b-card-title
                          >
                        </b-card-body>
                        <b-card-footer class="px-2">
                          <b-row no-gutters align-v="center">
                            <b-col cols="10">
                              <small>{{ file.type_of }}</small>
                              <br />
                              <small>{{ file.created_at }}</small>
                              <br />
                              <small>{{ file.size | formatSize }}</small>
                            </b-col>
                            <b-col cols="2" class="float-right">
                              <b-button-group size="sm" class="float-right">
                                <b-button
                                  v-if="!file.id"
                                  variant="danger"
                                  @click="
                                    actionClicked('delete', { item: file })
                                  "
                                >
                                  <i class="fa fa-trash"></i>
                                </b-button>
                              </b-button-group>
                            </b-col>
                          </b-row>
                        </b-card-footer>
                      </b-card>
                    </b-col>
                  </b-row>
                </b-card-group>
              </b-col>
            </b-row>

            <!--     <b-img
              src="https://picsum.photos/500/500/?image=54"
              fluid
              thumbnail
            ></b-img> -->
          </div>
        </b-card-body>
        <b-card-footer style="height: 50px">
          <b-button-group size="sm" class="float-right ml-1">
            <b-button
              variant="outline-primary"
              :pressed="filesview == 1"
              @click="filesview = 1"
              title="Details"
            >
              <i class="fa fa-list"></i>
            </b-button>
            <b-button
              variant="outline-primary"
              :pressed="filesview == 2"
              @click="filesview = 2"
              title="Thumbnails"
            >
              <i class="fa fa-image"></i>
            </b-button>
          </b-button-group>
        </b-card-footer>
      </b-card>

      <template #footer="{ hide }">
        <div class="d-flex bg-dark text-primary align-items-center px-3 py-2">
          <strong class="mr-auto">Documents</strong>
          <b-button size="sm" @click="hide">Close</b-button>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import gql from "graphql-tag";
import moment from "moment";

export default {
  name: "Sidebardocuments",
  data() {
    return {
      find: "",
      filter: "",
      filesview: 2,
      message: "",
      messagenofiles: "There are no files to show",
      uploadmessage: "",
      text: "",
      files: [
        {
          filename: "Client Contract 1.pdf",
          mymetype: "",
          encoding: "",
          size: "",
          path: "",
          url: "",
          type_of: "",
          created_at: "2021-04-21 14:36:18",
          updated_at: "2021-04-21 14:36:18",
          data: "",
        },
        {
          filename: "Client Contract 2.pdf",
          mymetype: "",
          encoding: "",
          size: "",
          path: "",
          url: "",
          type_of: "",
          created_at: "2021-04-21 14:36:18",
          updated_at: "2021-04-21 14:36:18",
          data: "",
        },
      ],
      options: {
        fields: [
          {
            key: "icon",
            label: "",
            class: "text-right",
          },
          {
            key: "filename",
            label: "Name",
            sortable: true,
          },
          {
            key: "updated_at",
            label: "Date Modified",
            sortable: true,
            formatter: (value, key, item) => {
              let result = "";
              if (value) {
                result = this.$moment(value).format("DD/MM/YYYY HH:mm:SS");
              }
              return result;
            },
          },
          {
            key: "type_of",
            label: "Type",
            sortable: true,
          },
          // {
          //   key: "size",
          //   label: "Size",
          //   sortable: true,
          //   class: "text-right",
          //   formatter: (value, key, item) => {
          //     return this.$options.filters.formatSize(value);
          //   }
          // },
          {
            key: "actions",
            label: "Actions",
            class: "pl-1 pr-1 w-140px",
          },
        ],
        badges: [
          {
            key: "type_of",
            type: "badge",
            other: "dark",
            Avatar: "danger",
            Companylogo: "light",
            Document: "primary",
            Image: "info",
            Certificate: "secondary",
            Registration: "warning",
            Deed: "warning",
            "Credit Reference": "success",
            License: "success",
            /* formatter: (value, key, item) => {
              return this.$options.filters.localise(value);
            }, */
          },
        ],
        actions: [
          {
            key: "delete",
            label: "Delete",
            icon: "fa fa-trash text-danger",
            single: true,
            multiple: true,
            overlay: {
              message: "Are you sure you want to delete row %name% ?",
              buttons: [
                {
                  label: "Yes",
                  variant: "danger",
                  dispatch: "delete",
                },
                {
                  label: "No",
                  class: "ml-2",
                },
              ],
            },
          },
        ],
      },
    };
  },
  methods: {
    async table_action(key, row) {
      this.$root.$emit("bv::hide::popover");
      console.log("you have clicked: ", key, row);

      this.search.selected = row.item;
      for (var i = 0; i < this.options.actions.length; i++) {
        if (this.options.actions[i].key == key) {
          if (this.options.actions[i].hasOwnProperty("modal")) {
            // this.selected = !Array.isArray(sender) ? [sender.item] : sender;
            // this.modal = this.actions[i].modal;
            // this.modalActive = true;
            console.log(this.options.modal);
            return;
          }
          if (this.options.actions[i].hasOwnProperty("component")) {
            this.options.component = this.options.actions[i].component;
            // ONLY ALLOW ONE EXPANSION
            for (var k = 0; k < this.items.length; k++) {
              this.$set(this.items[k], "_showDetails", false);
            }
            row.toggleDetails();
            return;
          }
          if (this.options.actions[i].hasOwnProperty("overlay")) {
            if (this.options.actions[i].overlay.message) {
              let message = this.options.actions[i].overlay.message;
              for (var prop in row.item) {
                if (Object.prototype.hasOwnProperty.call(row.item, prop)) {
                  message = message
                    .split("%" + prop + "%")
                    .join(row.item[prop]);
                }
              }
              this.options.overlay.message = message;
            }
            if (this.options.actions[i].overlay.buttons) {
              this.options.overlay.buttons = this.options.actions[
                i
              ].overlay.buttons;
            }
            this.options.overlay_show = !this.options.overlay_show;
            return;
          }
        }
      }
    },
    setIcon(filename) {
      let ext = filename.split(".").pop().toString().toLowerCase();
      switch (ext) {
        case "zip":
          return "fa-file-archive-o";
        case "txt":
          return "fa-file-text-o";
        case "pdf":
          return "fa-file-pdf-o";
        case "xls":
        case "xlsx":
          return "fa-file-excel-o";
        case "ppt":
        case "pptx":
          return "fa-file-powerpoint-o";
        case "doc":
        case "docx":
          return "fa-file-word-o";
        case "bmp":
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "tif":
        case "tiff":
          return "fa-file-image-o";
        case "mp4":
        case "mp3":
          return "fa-file-video-o";
        default:
          return "fa-file-o";
      }
    },
    badgeField(row, badge) {
      if (!row || !badge.key) return;
      var key = badge.key;
      if (!row.hasOwnProperty([badge.key])) {
        return;
      }
      var value = row[badge.key];
      if (badge.formatter) {
        value = badge.formatter(value, badge.key, row);
      }
      var badge = this.badges.find((k) => k.key == key);
      if (badge) {
        switch (badge.type) {
          case "pill":
            var badgeClass = badge.class;
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            value =
              "<span " +
              "title='" +
              badgeValue +
              "' " +
              "class='badge badge-" +
              badgeClass +
              " badge-pill'" +
              ">" +
              badgeValue +
              "</span>";
            break;

          case "badge":
            var badgeClass = badge[value];
            if (!badgeClass) {
              badgeClass = badge["other"];
            }
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            value =
              "<span " +
              "title='" +
              badgeValue +
              "' " +
              "class='badge badge-" +
              badgeClass +
              "'" +
              ">" +
              badgeValue +
              "</span>";
            break;

          case "switch":
            var badgeClass = badge[value];
            var badgeValue = value
              .toString()
              .replace(/^\w/, (c) => c.toUpperCase());
            var checked = "";
            if (value == "enabled") {
              checked = "checked";
            }
            value =
              "<label class='switch-sm switch  switch-label switch-" +
              badgeClass +
              " form-check-label'>" +
              "<input type='checkbox' true-value='" +
              badgeValue +
              "' false-value='no' class='switch-input form-check-input' value='" +
              badgeValue +
              "'" +
              checked +
              ">" +
              "<span class='switch-slider'></span></label>";
            break;

          case "progressbar":
            var badgeValue = value.toString(); //.substring(0,2)
            if (!badge.class) {
              badge.class = "success";
            }
            if (!badge.min) {
              badge.min = 0;
            }
            if (!badge.max) {
              badge.max = 100;
            }
            value =
              "<div role='progressbar' class='progress-bar bg-" +
              badge.class +
              "'" +
              "aria-valuemin='" +
              badge.min +
              "' " +
              "aria-valuemax='" +
              badge.max +
              "' " +
              "aria-valuenow='" +
              badgeValue +
              "' " +
              "title='" +
              badgeValue +
              "%' " +
              "style='width: " +
              badgeValue +
              "%;'>";
            if (badge.label) {
              value = value + badgeValue;
            }
            value = "</div><div class='progress'>" + value + "</div>";
            break;
        }
      }
      return value;
    },
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>

<style>
</style>